import LeftRightScrollButtonSmall from "components/LeftRightScrollButtonSmall";
import SimpleSlider from "components/SimpleSlider";
import React, { useEffect, useRef, useState } from "react";
import styles from "styles/modules/importClaims.module.scss";

const ClaimSummaryBox = ({ claim, customStyleVariant = "" }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const sliderRef = useRef();

  let textVariants = [claim.claimMatchText || claim.matchText];
  textVariants = textVariants.concat(
    claim.matchTextVariants?.map((variant) => variant.matchText) || []
  );

  const slides = textVariants.map((variant, index) => (
    <div key={index}>{variant}</div>
  ));

  useEffect(() => {
    goToSlide(currentSlideIndex);
  }, [currentSlideIndex]);

  const goToSlide = (slideIndex) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(slideIndex);
    }
  };

  const boxClassName = `${styles.elementxBox} ${
    styles[customStyleVariant] || ""
  }`;

  return (
    <div className={boxClassName}>
      <div className={styles.title}>
        <span>Match Text</span>
        <div className={`${styles.descriptionbox} customScrollBar`}>
          <SimpleSlider children={slides} sliderRef={sliderRef} />
        </div>
      </div>

      <div className={styles.moduleFooterRowInsideCard}>
        <LeftRightScrollButtonSmall
          count={slides.length}
          currentValue={currentSlideIndex + 1}
          handleClick={(direction) => {
            setCurrentSlideIndex((prev) =>
              direction === "forward"
                ? Math.min(prev + 1, slides.length - 1)
                : Math.max(prev - 1, 0)
            );
          }}
          shouldRightDisabled={currentSlideIndex === slides.length - 1}
          shouldLeftDisabled={currentSlideIndex === 0}
        />
      </div>
    </div>
  );
};

export default ClaimSummaryBox;
